import m from "./ghl-ui.es1436.js";
import f from "./ghl-ui.es1437.js";
import i from "./ghl-ui.es1508.js";
import s from "./ghl-ui.es1398.js";
function d(t, r) {
  s(2, arguments);
  var e = f(t), o = m(r), a = i(e) - o;
  return e.setUTCDate(e.getUTCDate() - a * 7), e;
}
export {
  d as default
};
